import React, { lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import LoadingCard from "../LoadingCard/loadingCard.component";

import { makeStyles } from "@material-ui/core/styles";
import "./newstile.styles.scss";

const MyCard = lazy(() => import("../Card/card.component"));

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "1.5rem",
  },
}));

export default function NewsTile({ data }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {Object.keys(data).map(
        (oneKey, i) =>
          Object.keys(data[oneKey]).length !== 0 && (
            <>
              <h3 key={i}>{oneKey.toUpperCase()}</h3>
              <div
                key={i}
                style={{
                  display: "flex",
                  marginTop: "1rem",
                  padding: "20px",
                }}
                className="row__posters"
              >
                {/* {console.log("DATA FUNC INNNN", data[oneKey])}
          {console.log("DATA FUNCINNNN TYPE", typeof data[oneKey])} */}
                <Suspense
                  className={classes.root}
                  fallback={<LoadingCard />}
                  key={i}
                >
                  {data[oneKey].map((data) => (
                    <>
                      {/* {console.log("DATA FUNC INNNN", data)} */}
                      <Link to={`/feeds/${oneKey}/${data.id}`} key={data.id}>
                        <MyCard
                          key={data.id}
                          url={data.url}
                          title={data.title}
                          data={data.date}
                          img={data.img}
                          image_title={data.image_title}
                          content={data.content}
                          description={data.description}
                        />
                      </Link>
                    </>
                  ))}
                </Suspense>
              </div>
            </>
          )
      )}
    </div>
  );
}
